import { useState, useCallback } from 'react';
import dayjs from 'dayjs';
import { capitalizeFirstLetter } from '../../utils';

export const DashboardLogic = () => {
    const [filterDates, setFilterDates] = useState({
        start_date: dayjs().subtract(30, 'days').startOf('day'),
        end_date: dayjs().endOf('day')
    });
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [summaryLoading, setSummaryLoading] = useState(false);

    const formatDateRange = useCallback(() => {
        return `${dayjs(filterDates.start_date).format('MM/DD/YYYY')} - ${dayjs(filterDates.end_date).format('MM/DD/YYYY')}`;
    }, [filterDates]);

    const startAndEndUnixDatesParams = useCallback(() => {
        return `start=${filterDates.start_date.unix()}&end=${filterDates.end_date.unix()}`;
    }, [filterDates]);

    const configureEventTypes = (data) => {
        const transformedData = data.map(item => ({
            type: capitalizeFirstLetter(item.type?.replace(/_/g, ' ').replace(/\s(\.)/g, ',')),
            value: item.value
        }));
        return transformedData;
    };

    return {
        // State
        filterDates,
        setFilterDates,
        selectedProjects,
        setSelectedProjects,
        summaryLoading,
        setSummaryLoading,
        // Functions
        configureEventTypes,
        formatDateRange,
        startAndEndUnixDatesParams,
    };
};
